import React from "react";
import "./CakeForm.css";
import { useState, useEffect } from "react";
// import { Select } from "antd";
import Multiselect from "multiselect-react-dropdown";
import Calc from "../functions/PriceCalc";
//axios
// import axios from "axios";
//toast notif
import { toast } from "react-toastify";
import { SyncOutlined } from "@ant-design/icons";
import { Modal } from "antd";
import { axiosInstance } from "../../config";

// const { Option } = Select;

function FormInput() {
  // const [selected, setSelected] = useState(false);

  const flavours = [
    { name: "Vanilla" },
    { name: "Salted caramel" },
    { name: "Chocolate" },
    { name: "Red velvet" },
    { name: "Lemon" },
    { name: "Strawberry" },
    { name: "Berry vanilla" },
    { name: "Double chocolate" },
    { name: "Champagne strawberry" },
  ];
  const [extraList] = useState([
    "Mini alcohol bottles",
    "Fruits",
    "Chocolates",
    "Candies",
    "Cookies",
    "Macarons",
  ]);

  const [order, setOrder] = useState({
    pastry: "Cake",
    name: "",
    contact: "",
    writingoncake: "",
    shape: "",
    flavour: "",
    size: "",
    delivery: "",
    extras: [],
    price: "0",
    extracost: "",
    totalPrice: 0,
  });
  const [extraPrice, setExtraPrice] = useState(0);
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);

  const handleChange = (e) => {
    setOrder({ ...order, [e.target.name]: e.target.value });
  };

  useEffect(() => {
    const z = Calc({
      size: order.size,
      flavour: order.flavour,
      price: order.price,
    });
    setOrder({
      ...order,
      price: z,
    });
    // eslint-disable-next-line
  }, [order.size, order.flavour, order.price]);
  const CalcExtra = () => {
    const exlen = order.extras.length;
    if (exlen === 0) {
      setExtraPrice(0);
    } else if (exlen === 1) {
      setExtraPrice(50);
    } else if (exlen === 2) {
      setExtraPrice(100);
    } else if (exlen === 3) {
      setExtraPrice(150);
    } else if (exlen === 4) {
      setExtraPrice(200);
    } else if (exlen === 5) {
      setExtraPrice(250);
    } else if (exlen === 6) {
      setExtraPrice(300);
    } else {
      setExtraPrice(0);
    }
  };

  useEffect(() => {
    CalcExtra();
  });

  //

  //handleSelect
  const handleSelect = (e) => {
    CalcExtra();
    setOrder({
      ...order,
      extras: e,
    });
  };

  const handleSubmit = async (e) => {
    try {
      setLoading(true);
      e.preventDefault();

      setOrder({ ...order, totalPrice: order.price + extraPrice });
      const { data } = await axiosInstance.post(`/api/cake`, {
        name: order.name,
        contact: order.contact,
        writingoncake: order.writingoncake,
        shape: order.shape,
        flavour: order.flavour,
        size: order.size,
        delivery: order.delivery,
        extras: order.extras,
        price: order.price + extraPrice,
      });
      toast.success("Order Placed. Screenshot pop-up for payment details");
      setVisible(true);
      setLoading(false);
      console.log(data);
    } catch (err) {
      setLoading(false);
      toast.error(err.response.data);
      return err;
    }
    // console.log("order details:", order);
    // console.log("order details", data);
  };
  console.log(order);
  console.log("ppp:", extraPrice);
  // console.log(order.extras.length);

  return (
    <>
      <form className="formInput">
        <div className="main-form">
          <div
            className="
        note"
          >
            <h1>
              <em>
                Price depends on the flavor of cake chosen plus size of cake
              </em>
            </h1>
            <h1>
              <em>
                Price include three layers of moist and decadent cakes with
                filling frosting and design.
              </em>
            </h1>
          </div>
          <div className="order-info">
            <div>
              <input
                name="name"
                type="text"
                placeholder="Name"
                onChange={handleChange}
              />
            </div>
            <div>
              <input
                name="contact"
                type="tel"
                placeholder="Contact"
                onChange={handleChange}
              />
            </div>
            <div>
              <input
                name="writingoncake"
                type="text"
                placeholder="Writing on cake"
                onChange={handleChange}
              />
            </div>
            <div>
              <input
                name="shape"
                type="text"
                placeholder="Cake Shape"
                onChange={handleChange}
              />
            </div>
            {/* flavour */}
            <div>
              <select
                className="select-option"
                name="flavour"
                onChange={handleChange}
                required
              >
                <option value="">-- Choose Flavour --</option>
                {flavours.map((flavour, index) => (
                  <option key={index} value={flavour.name}>
                    {flavour.name}
                  </option>
                ))}
              </select>
            </div>
            {/* size */}
            <div>
              <select
                className="select-option"
                name="size"
                onChange={handleChange}
                required
              >
                <option value="">-- Choose Size --</option>
                <option value="6">6" feeds 10 </option>
                <option value="8">8" feeds 18</option>
                <option value="10">10" feeds 25</option>
                <option value="12">12" feeds 40</option>
              </select>
            </div>
            {/* delivery */}
            <div
              className="
        note"
            >
              <h1>
                <em>
                  Delivery Cost will be charged by the rider,
                  <br />
                  make sure to contact us with your order details and the
                  location you want the order delivered to via whatsapp or call
                </em>
              </h1>
            </div>
            <div>
              <select
                className="select-option"
                name="delivery"
                onChange={handleChange}
                required
              >
                <option value="">-- Delivery Method --</option>
                <option value="Pickup">Pick Up</option>
                <option value="Delivery">Delivery</option>
              </select>
            </div>
          </div>

          <div className="sub-body">
            <h2 className="sub-body-text">
              Extras comes at an additional cost
            </h2>
          </div>
          <div className="radio-box-div">
            <Multiselect
              isObject={false}
              onRemove={handleSelect}
              onSelect={handleSelect}
              options={extraList}
              placeholder="Choose from available extras"
            />
          </div>

          <button
            onClick={handleSubmit}
            disabled={!order.name || !order.contact || loading}
          >
            {loading ? <SyncOutlined spin /> : "Order"}
          </button>
        </div>
      </form>
      <Modal
        title="PAYMENT DETAILS"
        centered
        visible={visible}
        onCancel={() => {
          setVisible(false);
        }}
        footer={null}
      >
        {/* order
        <pre>{JSON.stringify(order, null, 5)}</pre> */}
        <div className="modal-main">
          <div className="modal-details">
            <h3 className="m-heading">Oder Details</h3>
            <div className="m-details">
              <h1 className="m-label">Name: </h1>
              <h1 className="m-details">{order.name}</h1>
            </div>
            <div className="m-details">
              <h1 className="m-label">Contact: </h1>
              <h1 className="m-details">{order.contact}</h1>
            </div>
            <div className="m-details">
              <h1 className="m-label">Order Type: </h1>
              <h1 className="m-details">{order.pastry}</h1>
            </div>
            <div className="m-details">
              <h1 className="m-label">Writing On Cake: </h1>
              <h1 className="m-details">{order.writingoncake}</h1>
            </div>
            <div className="m-details">
              <h1 className="m-label">Shape: </h1>
              <h1 className="m-details">
                {order.shape
                  ? order.shape
                  : "Have no shape in mind? Don't worry we will surprise you"}
              </h1>
            </div>
            <div className="m-details">
              <h1 className="m-label">Flavour: </h1>
              <h1 className="m-details">{order.flavour}</h1>
            </div>
            <div className="m-details">
              <h1 className="m-label">Size: </h1>
              <h1 className="m-details">{order.size + " pounds"}</h1>
            </div>
            <div className="m-details">
              <h1 className="m-label">Delivery Method: </h1>
              <h1 className="m-details">{order.delivery}</h1>
            </div>
            <div className="m-details">
              <h1 className="m-label">Total: </h1>
              <h1 className="m-details">{order.totalPrice + " GHC"}</h1>
            </div>
          </div>
          <div className="modal-payment">
            <h1 className="m-label">
              Make payment of {order.totalPrice + " GHC"} to{" "}
              <span className="m-number">0553009397 or 0509034660</span>{" "}
            </h1>
            <h1>
              Use your <span className="m-number">Name</span> or{" "}
              <span className="m-number"> Number</span> as Reference
            </h1>
          </div>
        </div>
      </Modal>
    </>
  );
}

export default FormInput;
